import CustomConfirmationDialog from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';
import { postData } from '../../../../../../api/componentAPIs';

export default ({
  selectedHolidayData,
  onCancel,
  refreshData,
  enqueueSnackbar,
  customerDetails
}) => {
  const deleteHoliday = () => {
    const holidayData = selectedHolidayData;
    if (!holidayData) {
      return;
    }
    const requestParams = {
      holidayId: holidayData.holidayId,
      customerCode: customerDetails.customerCode,
      terminalId: customerDetails.terminalId,
      isCustomerSpecificHoliday: holidayData.isCustomerSpecificHoliday,
    };
    postData('DeleteCustomerHolidays', requestParams)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          enqueueSnackbar(`Deleted holiday '${holidayData.holidayName}'`, {
            variant: 'success',
            style:{ wordBreak: 'break-word' }
          });
          refreshData(holidayData?.holidayDate,holidayData?.holidayEndDate);
          onCancel();
        } else {
          handleError({ statusCode: response.status });
        }
      })
      .catch(() => {
        handleError({});
      });
  };

  const handleError = ({ statusCode }) => {
    if (statusCode !== 403) {
      enqueueSnackbar(`Error deleted holiday '${selectedHolidayData.holidayName}'`, {
        variant: 'error',
        style:{ wordBreak: 'break-word' }
      });
    }
    onCancel();
  };

  return (
    <>
      {selectedHolidayData && (
        <CustomConfirmationDialog
          title="Delete Holiday"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Remove"
          mode="danger"
          onConfirm={deleteHoliday}
          onCancel={onCancel}>
          {`Are you sure you want to delete selected holiday "${selectedHolidayData.holidayName}" from holidayList?`}
        </CustomConfirmationDialog>
      )}
    </>
  );
};
